import { render, staticRenderFns } from "./VolunteerShow.vue?vue&type=template&id=2beeb568&scoped=true&lang=pug&"
import script from "./VolunteerShow.vue?vue&type=script&lang=js&"
export * from "./VolunteerShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beeb568",
  null
  
)

export default component.exports